<div [formGroup]="myGroup" class="input-html-element-container">
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{name}}</mat-label>
        <input matInput formControlName="customElement" (input)="OnChanged($event)" />
        <mat-icon matSuffix *ngIf="name === 'name'">label</mat-icon>
        <mat-icon matSuffix *ngIf="name === 'label'">text_fields</mat-icon>
    </mat-form-field>
</div>